import styled from 'styled-components';
import { Button, Header as HeaderLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const ContainerButtons = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
`;

export const Card = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  background-color: ${(props) => props.theme.color.white};
  border: 1px solid ${(props) => props.theme.color.segmentBorder};
  border-radius: 4px;
  padding: 20px;
  width: 400px;
  height: 200px;
  flex-direction: column;
`;

export const Title = styled(HeaderLayoutComponent)``;

export const PrimaryButton = styled(Button)`
  width: 120px;
`;

export const SecondaryButton = styled(Button.Inverted)`
  width: 120px;
`;
